import { ChevronDown, ChevronRight, UserRoundPlus } from "lucide-react";
import React from "react";

export default function MyCard10({ label = "", value = "", icon, iconColor }) {
  const Icon = icon ?? UserRoundPlus;
  return (
    <div className=" w-full flex items-center justify-start dark:bg-slate-700/80 bg-slate-200 p-4 space-x-3 rounded-xl">
      <Icon
        style={{ color: iconColor ?? "#da2121" }}
        className="rounded-full p-3 font-bold shadow  bg-amber-50/90"
        size={50}
        scale={2}
      />
      <div className="flex flex-col space-y-1">
        <span className="text-sm text-slate-700 dark:text-slate-400 font-semibold tracking-wider">
          {label}
        </span>
        <span className=" text-md text-slate-700 dark:text-slate-200 font-bold font-sans tracking-wider">
          {value}
        </span>
      </div>
      <ChevronRight size={26} className="ml-auto text-slate-500 dark:text-slate-500" />
    </div>
  );
}
